class ApplyForm extends BaseForm {
    constructor(options) {
        super(options);

        //set default variables
        this.fields = [
            {name: 'career_id'},
            {name: 'branch_id'},
            {name: 'consent'},
            {name: 'first_name',pattern: /^.{2,}$/i},
            {name: 'last_name',pattern: /^.{2,}$/i},
            {name: 'email', type: 'email'},
            {name: 'phone', type: 'phone'},
            {name: 'cv', filetype: '.pdf,.doc,.docx', filesize: 3000000},
            {name: 'letter', filetype: '.pdf,.doc,.docx', filesize: 3000000, required: false},
            {name: 'linkedin', required: false, pattern: /^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?$/i},
            {name: 'message', required: false}
        ];

        this.$btnClose = this.$('.btn-close');
    }

    addDispatchListener(){
        Me.dispatch.subscribe('Career.prefillInfos',  (e, params)=> this.prefillInfos(e, params));
    }

    addEvents() {
        super.addEvents();

        this.$btnClose.on('click', (e)=> this.clickHandler(e));
        this.$('.fake-input').on('click', (e)=> this.fakeInputHandler(e));
        this.$phone.on('blur', (e)=>this.handlePhoneState(e));
        this.$email.on('blur', (e)=>this.handleEmailState(e));

        this.$('[type=file]').on('change', (e) => this.handleName(e));

    }

    handleName(e){
        let $input = $(e.currentTarget);
        let id = $input.attr('id');
        let $label = this.$('[for='+ id +']');
        let $fileName = $label.find('.file-name');

        let	name = ($input[0].files.length > 0) ? $input[0].files[0].name : $fileName.attr('data-placeholder');
        $fileName.html(name);
    }

    removeEvents() {
        this.$btnClose.off('click', (e)=> this.clickHandler(e));
        Me.dispatch.unsubscribe('Career.prefillInfos',  (e, params)=> this.prefillInfos(e, params));

    }

    clickHandler(e){
        e.preventDefault();
        Me.dispatch.emit('close-modal', this, {name: this.name});
    }

    prefillInfos(e, params) {
        if (params.branchId) {
            if(params.branchTitle){
                this.$('#branch_name').val(params.branchTitle);
            }
            this.$('#branch_id').val(params.branchId);
        }
        // @NOTE 4C4 - NOT NEEDED
        // if (params.careerId) {
        //     if(params.careerTitle){
        //         let careerTitleToText = params.careerTitle.replace('&nbsp;', ' ');
        //         this.$('#career_name').val(careerTitleToText);
        //     }
        //     this.$('#career_id').val(params.careerId);
        // }
    }

    fakeInputHandler(e) {
        $(e.currentTarget).siblings('input').trigger('click');
    }

    doTracking(){
        let restaurant = this.$('#branch_name').val();
        let jobTitle = this.$('#career_name').val();

        Me.track.event(restaurant + " career", "Submit", jobTitle);
    }
}

